import React from 'react';
import PropTypes from 'prop-types';

import { WOODSMOKE } from '@constant/colors';

/* eslint-disable react/prop-types */
const renderFlat = ({ className, color, onClick, width, height }) => {
  if (!height) {
    height = Math.round(width / 44) * 21;
  }
  return (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 44 21"
    >
      <defs>
        <path
          id="logo-path"
          d="M25.4 10.6c0-6.2 4.4-9.9 10.1-9.9C40.6.7 44 3.3 44 6.9c0 3.4-2.9 5.6-6.1 5.6-1.8 0-3.1-.3-4-1-.3-.3-.5-.2-.5.1 0 1.3.5 2.3 1.3 3.2.7.7 2 1.2 3.2 1.2 1.3 0 2.4-.3 3.4-.8s1.8-.3 2.3.5c.6.9-.2 2.1-.9 2.9-1.3 1.4-3.8 2.4-7 2.4-6.5-.2-10.3-4.6-10.3-10.4zm-13.3 4.1c.6 0 1 .3 1.4 1l1.8 2.9c.7 1.1 1.3 1.9 2.6 1.9s2-.5 2.6-2c.8-1.8 1.7-4.1 2.4-7.1.9-3.4 1.3-5.4 1.3-7.1s-.5-2.7-2.4-3c-2.5-.5-6-.7-9.7-.7s-7.2.2-9.7.6C.5 1.6 0 2.6 0 4.3S.4 8 1.2 11.4c.8 3 1.6 5.2 2.4 7.1.7 1.5 1.3 2 2.6 2s1.9-.8 2.6-1.9l1.8-2.9c.5-.6.9-1 1.5-1z"
        />
      </defs>
      <g fill="none" className="logo-shape">
        <use fill={color} fillRule="evenodd" xlinkHref="#logo-path" />
      </g>
    </svg>
  );
};

/* eslint-disable react/prop-types */
const renderShadow = ({ className, color, onClick, width, height }) => {
  if (!height) {
    height = Math.round(width / 52) * 29;
  }
  return (
    // width: 4px shadow both sides
    <svg
      onClick={onClick}
      width={width + 8}
      height={height}
      className={className}
      viewBox="-4 -2 52 29"
    >
      <defs>
        <path
          id="logo-path"
          d="M25.4 10.6c0-6.2 4.4-9.9 10.1-9.9C40.6.7 44 3.3 44 6.9c0 3.4-2.9 5.6-6.1 5.6-1.8 0-3.1-.3-4-1-.3-.3-.5-.2-.5.1 0 1.3.5 2.3 1.3 3.2.7.7 2 1.2 3.2 1.2 1.3 0 2.4-.3 3.4-.8s1.8-.3 2.3.5c.6.9-.2 2.1-.9 2.9-1.3 1.4-3.8 2.4-7 2.4-6.5-.2-10.3-4.6-10.3-10.4zm-13.3 4.1c.6 0 1 .3 1.4 1l1.8 2.9c.7 1.1 1.3 1.9 2.6 1.9s2-.5 2.6-2c.8-1.8 1.7-4.1 2.4-7.1.9-3.4 1.3-5.4 1.3-7.1s-.5-2.7-2.4-3c-2.5-.5-6-.7-9.7-.7s-7.2.2-9.7.6C.5 1.6 0 2.6 0 4.3S.4 8 1.2 11.4c.8 3 1.6 5.2 2.4 7.1.7 1.5 1.3 2 2.6 2s1.9-.8 2.6-1.9l1.8-2.9c.5-.6.9-1 1.5-1z"
        />
        <filter
          id="logo-filter"
          width="200%"
          height="200%"
          x="-50%"
          y="-50%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="2"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
        </filter>
      </defs>
      <g fill="none" className="logo-shape">
        <use
          fill={WOODSMOKE}
          fillOpacity="0.11"
          filter="url(#logo-filter)"
          xlinkHref="#logo-path"
        />
        <use fill={color} fillRule="evenodd" xlinkHref="#logo-path" />
      </g>
    </svg>
  );
};

const Logo = (props) => {
  return props.shadow ? renderShadow(props) : renderFlat(props);
};

Logo.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  shadow: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
};

Logo.defaultProps = {
  className: 'logo',
  shadow: false,
  width: 42,
};

export default Logo;
